
window.ExXtraAddToCart = (() => {
    const DELIVERY_FEE_VARIANT_ID = 67236771889227;

    async function add({
        variantId,
        sellingPlan = null,
        quantity = 1,
        properties = {},
        address = null,
        insurance = [],
        redirect = true
    }) {
        if (!variantId) {
            throw new Error("Variant ID is required.");
        }

        try {
            // Reuse the booking ID created by ValetBookNow.
            const batchId =
                properties.batch_id ||
                (
                    "valet-" +
                    Date.now() +
                    "-" +
                    Math.random().toString(36).slice(2, 9)
                );

            const bookingProperties = {
                ...properties,
                batch_id: batchId
            };

            /*
             * Save booking details for checkout autofill.
             */
            if (address) {
                localStorage.setItem(
                    "exxtra_booking_service",
                    "valet-storage"
                );

                localStorage.setItem(
                    "valet_booking_address",
                    JSON.stringify(address)
                );

                localStorage.setItem(
                    "valet_booking_properties",
                    JSON.stringify(bookingProperties)
                );
            }

            /*
             * Check existing cart items.
             */
            const cartResponse = await fetch("/cart.js", {
                headers: {
                    "Accept": "application/json"
                }
            });

            if (!cartResponse.ok) {
                throw new Error("Unable to check the current cart.");
            }

            const cart = await cartResponse.json();

            const feeAlreadyInCart = (cart.items || []).some(item =>
                Number(item.variant_id) ===
                Number(DELIVERY_FEE_VARIANT_ID)
            );

            /*
             * Add the main Valet Storage product.
             */
            const itemsToAdd = [
                {
                    id: Number(variantId),
                    quantity: Number(quantity),
                    properties: bookingProperties,
                    ...(sellingPlan
                        ? { selling_plan: String(sellingPlan) }
                        : {})
                }
            ];

            /*
             * Add CrownCare insurance to the same booking batch.
             */
            for (const insuranceItem of insurance) {
                if (!insuranceItem.variantId) continue;

                const insuranceProperties = {
                    "Insurance Box": `Box #${insuranceItem.box}`,
                    insured_box_number: String(insuranceItem.box),
                    batch_id: batchId
                };

                itemsToAdd.push({
                    id: Number(insuranceItem.variantId),
                    quantity: 1,
                    properties: insuranceProperties
                });
            }

            /*
             * Add the one-time delivery fee only if it is not
             * already present in the cart.
             */
            if (!feeAlreadyInCart) {
                itemsToAdd.push({
                    id: Number(DELIVERY_FEE_VARIANT_ID),
                    quantity: 1,
                    properties: {
                        "Fee Type": "One-Time Box Delivery & Pickup Fee",
                        "Storage Duration":
                            bookingProperties["Storage Duration"] || "",
                        "Number of Crates": String(quantity),
                        batch_id: batchId
                    }
                });
            }

            /*
             * Add all items together.
             */
            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    items: itemsToAdd
                })
            });

            if (!response.ok) {
                const error = await response.json();

                throw new Error(
                    error.description ||
                    "Unable to add the booking to the cart."
                );
            }

            const result = await response.json();

            const item = result.items?.find(
                cartItem =>
                    Number(cartItem.id) === Number(variantId)
            ) || result;

            if (redirect) {
                window.location.href = "/cart";
            }

            return item;

        } catch (error) {
            console.error("[Valet Add To Cart]", error);
            throw error;
        }
    }

    return { add };
})();
